import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchMenus,
  fetchMenusSuccess,
  fetchMenusFailure,
} from "../slices/menuSlice"; // ✅ FIXED

// API
const fetchMenusAPI = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/v1/menus`);
  const result = await res.json();
  return result.data;
};

function* handleFetchMenus() {
  try {
    const data = yield call(fetchMenusAPI);
    yield put(fetchMenusSuccess(data));
  } catch (err) {
    yield put(fetchMenusFailure("Error"));
  }
}

export function* watchMenuSaga() {
  yield takeLatest(fetchMenus.type, handleFetchMenus);
}
